<script setup>
import { ref, onMounted } from 'vue'

const isOpen = ref(false)

const toggle = () => {
  isOpen.value = !isOpen.value
}

// Dynamic channel list built from API
const channels = ref([])

const phoneIcon = `<svg viewBox="0 0 24 24" class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.1 1.22 2 2 0 012.1 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14.92z"/></svg>`

const emailIcon = `<svg viewBox="0 0 24 24" class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>`

const lineIcon = `<svg viewBox="0 0 24 24" class="w-5 h-5" fill="currentColor"><path d="M 19.365 9.863 c 0.349 0 0.63 0.285 0.63 0.631 0 0.345 -0.281 0.63 -0.63 0.63 H 17.61 v 1.125 h 1.755 c 0.349 0 0.63 0.283 0.63 0.63 0 0.344 -0.281 0.629 -0.63 0.629 h -2.386 c -0.345 0 -0.627 -0.285 -0.627 -0.629 V 8.108 c 0 -0.345 0.282 -0.63 0.627 -0.63 h 2.386 c 0.346 0 0.627 0.285 0.627 0.63 0 0.349 -0.281 0.63 -0.63 0.63 H 17.61 v 1.125 h 1.755 z m -3.855 3.016 c 0 0.27 -0.174 0.51 -0.432 0.596 -0.064 0.021 -0.133 0.031 -0.199 0.031 -0.211 0 -0.391 -0.09 -0.51 -0.25 l -2.443 -3.317 v 2.94 c 0 0.344 -0.279 0.629 -0.631 0.629 -0.346 0 -0.626 -0.285 -0.626 -0.629 V 8.108 c 0 -0.27 0.173 -0.51 0.43 -0.595 0.06 -0.023 0.136 -0.033 0.194 -0.033 c 0.195 0 0.375 0.104 0.495 0.254 l 2.462 3.33 V 8.108 c 0 -0.345 0.282 -0.63 0.63 -0.63 c 0.345 0 0.63 0.285 0.63 0.63 v 4.771 z m -5.741 0 c 0 0.344 -0.282 0.629 -0.631 0.629 c -0.345 0 -0.627 -0.285 -0.627 -0.629 V 8.108 c 0 -0.345 0.282 -0.63 0.627 -0.63 c 0.346 0 0.628 0.285 0.628 0.63 v 4.771 z m -2.466 0.629 H 4.917 c -0.345 0 -0.63 -0.285 -0.63 -0.629 V 8.108 c 0 -0.345 0.285 -0.63 0.63 -0.63 c 0.348 0 0.63 0.285 0.63 0.63 v 4.141 h 1.756 c 0.348 0 0.629 0.283 0.629 0.63 0 0.344 -0.282 0.629 -0.629 0.629 M 24 10.314 C 24 4.943 18.615 0.572 12 0.572 S 0 4.943 0 10.314 c 0 4.811 4.27 8.842 10.035 9.608 c 0.391 0.082 0.923 0.258 1.058 0.59 c 0.12 0.301 0.079 0.766 0.038 1.08 l -0.164 1.02 c -0.045 0.301 -0.24 1.186 1.049 0.645 c 1.291 -0.539 6.916 -4.078 9.436 -6.975 C 23.176 14.393 24 12.458 24 10.314"/></svg>`

const facebookIcon = `<svg viewBox="0 0 24 24" class="w-5 h-5" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>`

const aiIcon = `<svg viewBox="0 0 24 24" class="w-5 h-5 sparkle-icon" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.813 15.904L9 21l-1.813-5.096L2.091 15 7.187 13.187 9 8l1.813 5.187L15.909 15l-5.096.904zM19.006 5.005L18.5 8l-.506-2.995L15 4.5l2.994-.505L18.5 1l.506 2.995L22 4.5l-2.994.505zM17.006 17.005L16.5 20l-.506-2.995L13 16.5l2.994-.505L16.5 13l.506 2.995L20 16.5l-2.994.505z" /></svg>`

const buildChannels = (phones, emails, lines, facebookUrl = '', storeName = '') => {
  const result = []

  // Quotation Request entry
  result.push({
    id: 'quotation-request',
    label: 'ขอใบเสนอราคาฟรี',
    sublabel: 'ประเมินพื้นที่ / ติดตั้ง',
    href: '/quotation',
    isRoute: true,
    bg: 'bg-gradient-to-r from-emerald-600 to-teal-700',
    hoverBg: 'hover:from-emerald-500 hover:to-teal-600',
    icon: emailIcon
  })

  // LINE entries
  lines.forEach((line, i) => {
    result.push({
      id: 'line-' + i,
      label: line.name ? `LINE — ${line.name}` : 'LINE',
      sublabel: line.value,
      href: line.url || `https://line.me/ti/p/~${line.value}`,
      bg: 'bg-[#06C755]',
      hoverBg: 'hover:bg-[#05b04c]',
      icon: lineIcon
    })
  })

  // Phone entries
  phones.forEach((phone, i) => {
    result.push({
      id: 'phone-' + i,
      label: phone.name ? `โทร — ${phone.name}` : 'โทรศัพท์',
      sublabel: phone.value,
      href: 'tel:' + phone.value.replace(/[^0-9+]/g, ''),
      bg: 'bg-emerald-600',
      hoverBg: 'hover:bg-emerald-500',
      icon: phoneIcon
    })
  })

  // Facebook
  if (facebookUrl) {
    result.push({
      id: 'facebook',
      label: 'Facebook',
      sublabel: storeName || 'ติดตามข่าวสาร',
      href: facebookUrl,
      bg: 'bg-[#1877F2]',
      hoverBg: 'hover:bg-[#166fe5]',
      icon: facebookIcon
    })
  }

  // Email entries
  emails.forEach((email, i) => {
    result.push({
      id: 'email-' + i,
      label: email.name ? `อีเมล — ${email.name}` : 'อีเมล',
      sublabel: email.value,
      href: 'mailto:' + email.value,
      bg: 'bg-gray-700',
      hoverBg: 'hover:bg-gray-600',
      icon: emailIcon
    })
  })

  return result
}

onMounted(async () => {
  let phones = []
  let emails = []
  let lines = []
  let facebookUrl = ''
  let storeName = ''

  try {
    const res = await fetch('/api/settings/public')
    const data = await res.json()
    if (data.success && data.data) {
      storeName = data.data.store_name || ''
      facebookUrl = data.data.contact_facebook_url || ''
      if (data.data.contact_phones) {
        try { const p = typeof data.data.contact_phones === 'string' ? JSON.parse(data.data.contact_phones) : data.data.contact_phones; if (Array.isArray(p) && p.length) phones = p } catch (e) {}
      }
      if (data.data.contact_emails) {
        try { const e = typeof data.data.contact_emails === 'string' ? JSON.parse(data.data.contact_emails) : data.data.contact_emails; if (Array.isArray(e) && e.length) emails = e } catch (e) {}
      }
      if (data.data.contact_lines) {
        try { const l = typeof data.data.contact_lines === 'string' ? JSON.parse(data.data.contact_lines) : data.data.contact_lines; if (Array.isArray(l) && l.length) lines = l } catch (e) {}
      }
    }
  } catch (error) {
    console.error('Failed to load contact for floating button:', error)
  }

  channels.value = buildChannels(phones, emails, lines, facebookUrl, storeName)
})
</script>

<template>
  <!-- Contact Floating Button Stack -->
  <div class="fixed bottom-[86px] right-6 z-40 flex flex-col items-end gap-2">

    <!-- Channel items (expand upward when open) -->
    <transition-group name="channel-list" tag="div" class="flex flex-col items-end gap-2">
      <component
        :is="channel.isRoute ? 'router-link' : 'a'"
        v-if="isOpen"
        v-for="channel in channels"
        :key="channel.id"
        :to="channel.isRoute ? channel.href : undefined"
        :href="!channel.isRoute ? channel.href : undefined"
        :target="!channel.isRoute ? '_blank' : undefined"
        :rel="!channel.isRoute ? 'noopener noreferrer' : undefined"
        @click="channel.isRoute ? (isOpen = false) : undefined"
        :class="[channel.bg, channel.hoverBg]"
        class="flex items-center gap-2.5 text-white rounded-full shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200 pl-3.5 pr-4 py-1.5 group min-w-[180px]"
      >
        <div class="flex-shrink-0 w-7 h-7 bg-white/20 rounded-full flex items-center justify-center">
          <span v-html="channel.icon"></span>
        </div>
        <div class="leading-tight">
          <div class="text-xs font-black tracking-wide">{{ channel.label }}</div>
          <div class="text-[10px] opacity-80">{{ channel.sublabel }}</div>
        </div>
      </component>
    </transition-group>

    <!-- Toggle Button -->
    <button
      @click="toggle"
      :class="isOpen ? 'bg-red-500 hover:bg-red-600' : 'bg-gradient-to-br from-emerald-500 to-emerald-700 hover:from-emerald-400 hover:to-emerald-600'"
      class="w-[50px] h-[50px] rounded-full text-white shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center justify-center overflow-hidden"
      :title="isOpen ? 'ปิด' : 'ติดต่อเรา'"
    >
      <!-- Close (X) Icon when open -->
      <svg v-if="isOpen" key="close" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
      <!-- Chat Bubble Icon when closed -->
      <svg v-else key="chat" class="w-[22px] h-[22px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    </button>
  </div>
</template>

<style scoped>
.channel-list-enter-active {
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.channel-list-leave-active {
  transition: all 0.2s ease-in;
}
.channel-list-enter-from {
  opacity: 0;
  transform: translateY(20px) scale(0.8);
}
.channel-list-leave-to {
  opacity: 0;
  transform: translateY(10px) scale(0.9);
}


/* Premium AI Button Animations & Styling */
@keyframes pulse-glow {
  0% {
    box-shadow: 0 4px 15px rgba(139, 92, 246, 0.45), 0 0 0 0px rgba(139, 92, 246, 0.3);
  }
  70% {
    box-shadow: 0 4px 22px rgba(139, 92, 246, 0.55), 0 0 0 8px rgba(139, 92, 246, 0);
  }
  100% {
    box-shadow: 0 4px 15px rgba(139, 92, 246, 0.45), 0 0 0 0px rgba(139, 92, 246, 0);
  }
}

@keyframes shimmer {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes shine {
  0% { left: -150%; }
  50% { left: -150%; }
  100% { left: 150%; }
}

@keyframes spin-slow {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.ai-btn-premium {
  position: relative;
  background: linear-gradient(135deg, #7c3aed, #d946ef, #4f46e5);
  background-size: 200% 200%;
  animation: pulse-glow 2.5s infinite, shimmer 6s ease infinite;
  overflow: hidden;
}

.ai-btn-premium:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 25px rgba(139, 92, 246, 0.6);
}

.ai-btn-premium:hover .sparkle-icon {
  animation: spin-slow 4s linear infinite;
}

/* Shimmer sweeping beam effect */
.ai-btn-premium::before {
  content: '';
  position: absolute;
  top: 0;
  left: -150%;
  width: 40%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.4) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: skewX(-25deg);
  animation: shine 4.5s infinite ease-in-out;
}
</style>
